export const has = (obj, key) => {
    return key.split('.').every(function (x) {
        if (typeof obj != 'object' || obj === null || !(x in obj)) return false
        obj = obj[x]
        return true
    })
}

export const isEmpty = (value, type) => {
    if (Array.isArray(value) && value.length === 0) return true
    if (value === undefined || value === null || value === '' || value === {})
        return true
    if (type === 'number' && value === 0) return true
    return false
}

export const blobFileToBase64 = (blobFile) =>
    new Promise((resolve, reject) => {
        if (!blobFile) {
            console.error('ArgumentException')
            reject()
        }
        let reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = (e) => {
            console.error(e)
            reject(e)
        }
        reader.readAsDataURL(blobFile)
    })

export const getBase64ImageSize = (base64Image) =>
    new Promise((resolve, reject) => {
        if (!base64Image) {
            console.error('ArgumentException')
            reject()
        }
        let image = new Image()
        image.onload = function () {
            resolve({ height: this.height, width: this.width })
        }
        image.onerror = function () {
            console.error()
            reject()
        }
        image.src = base64Image
    })
